import type { Component } from 'vue';
import {
  LineBars,
  LineEllipsisH,
  LineBox,
  LineInbox,
  LineFont,
  LineImage,
  LineShieldCheck,
  LineUsdCircle,
  LineToggleOn,
  LineAngleDown,
  LineAngleRight,
  LineListUl,
  LineListOl,
  LineCheckCircle,
  LineCopy,
  LineDraggabledots,
  LineTrashAlt,
  LinePlus,
  LineEye,
  LineTruck,
  LineRefresh,
  LineSetting,
} from '@pulse/components/icons';

/**
 * Maps the `icon` name stored on each catalog entry to a real Pulse icon component.
 * Centralising the imports here keeps the catalog data plain (string names) and
 * guarantees every referenced icon actually exists at build time.
 */
export const BUILDER_ICONS: Record<string, Component> = {
  LineAngleDown,
  LineAngleRight,
  LineBars,
  LineBox,
  LineCheckCircle,
  LineEllipsisH,
  LineFont,
  LineImage,
  LineInbox,
  LineListOl,
  LineListUl,
  LineRefresh,
  LineShieldCheck,
  LineToggleOn,
  LineTruck,
  LineUsdCircle,
};

/** Fallback icon for unknown element types. */
export const UNKNOWN_ELEMENT_ICON = LineBox;

// Chrome icons used by the builder UI itself (not element-type icons).
export const ICON_DRAG_HANDLE = LineDraggabledots;
export const ICON_DELETE = LineTrashAlt;
export const ICON_DUPLICATE = LineCopy;
export const ICON_EXPANDED = LineAngleDown;
export const ICON_COLLAPSED = LineAngleRight;
export const ICON_ADD = LinePlus;
export const ICON_PREVIEW = LineEye;
export const ICON_SETTINGS = LineSetting;

export function resolveElementIcon(name: string | undefined): Component {
  return (name && BUILDER_ICONS[name]) || UNKNOWN_ELEMENT_ICON;
}
